<template>
  <div class="mobile-auth-container">
    <div class="mobile-auth-card">
      <!-- Logo Section -->
      <div class="auth-logo">
        <img src="@/assets/logo.jpg" alt="Gypsy Souls" class="auth-logo-img" />
        <p>Welcome to your next adventure!</p>
      </div>

      <!-- Step 1: Mobile Number Entry -->
      <div v-if="currentStep === 1" class="auth-step">
        <h4 class="step-title">
          <i class="fas fa-user-plus me-2"></i>
          Get Started
        </h4>
        <p class="step-subtitle">
          Enter your mobile number to sign up or login
        </p>

        <form @submit.prevent="checkUserAndLogin">
          <div class="mb-3">
            <label for="mobileNumber" class="form-label">Mobile Number</label>
            <div class="input-group">
              <select
                class="form-select"
                v-model="form.countryCode"
                style="max-width: 120px"
              >
                <option value="91">🇮🇳 +91</option>
                <option value="1">🇺🇸 +1</option>
                <option value="44">🇬🇧 +44</option>
                <option value="33">🇫🇷 +33</option>
                <option value="49">🇩🇪 +49</option>
                <option value="81">🇯🇵 +81</option>
                <option value="86">🇨🇳 +86</option>
                <option value="82">🇰🇷 +82</option>
                <option value="61">🇦🇺 +61</option>
                <option value="55">🇧🇷 +55</option>
                <option value="52">🇲🇽 +52</option>
                <option value="39">🇮🇹 +39</option>
                <option value="34">🇪🇸 +34</option>
                <option value="31">🇳🇱 +31</option>
                <option value="46">🇸🇪 +46</option>
                <option value="47">🇳🇴 +47</option>
                <option value="45">🇩🇰 +45</option>
                <option value="41">🇨🇭 +41</option>
                <option value="43">🇦🇹 +43</option>
                <option value="32">🇧🇪 +32</option>
                <option value="351">🇵🇹 +351</option>
                <option value="30">🇬🇷 +30</option>
                <option value="90">🇹🇷 +90</option>
                <option value="7">🇷🇺 +7</option>
                <option value="380">🇺🇦 +380</option>
                <option value="48">🇵🇱 +48</option>
                <option value="420">🇨🇿 +420</option>
                <option value="421">🇸🇰 +421</option>
                <option value="36">🇭🇺 +36</option>
                <option value="40">🇷🇴 +40</option>
                <option value="359">🇧🇬 +359</option>
                <option value="385">🇭🇷 +385</option>
                <option value="386">🇸🇮 +386</option>
                <option value="372">🇪🇪 +372</option>
                <option value="371">🇱🇻 +371</option>
                <option value="370">🇱🇹 +370</option>
                <option value="353">🇮🇪 +353</option>
                <option value="358">🇫🇮 +358</option>
                <option value="354">🇮🇸 +354</option>
                <option value="376">🇦🇩 +376</option>
                <option value="377">🇲🇨 +377</option>
                <option value="378">🇸🇲 +378</option>
                <option value="39">🇻🇦 +39</option>
                <option value="423">🇱🇮 +423</option>
                <option value="65">🇸🇬 +65</option>
                <option value="60">🇲🇾 +60</option>
                <option value="66">🇹🇭 +66</option>
                <option value="84">🇻🇳 +84</option>
                <option value="63">🇵🇭 +63</option>
                <option value="62">🇮🇩 +62</option>
                <option value="880">🇧🇩 +880</option>
                <option value="94">🇱🇰 +94</option>
                <option value="977">🇳🇵 +977</option>
                <option value="975">🇧🇹 +975</option>
                <option value="960">🇲🇻 +960</option>
                <option value="93">🇦🇫 +93</option>
                <option value="92">🇵🇰 +92</option>
                <option value="98">🇮🇷 +98</option>
                <option value="964">🇮🇶 +964</option>
                <option value="963">🇸🇾 +963</option>
                <option value="961">🇱🇧 +961</option>
                <option value="972">🇮🇱 +972</option>
                <option value="970">🇵🇸 +970</option>
                <option value="962">🇯🇴 +962</option>
                <option value="965">🇰🇼 +965</option>
                <option value="974">🇶🇦 +974</option>
                <option value="973">🇧🇭 +973</option>
                <option value="971">🇦🇪 +971</option>
                <option value="968">🇴🇲 +968</option>
                <option value="966">🇸🇦 +966</option>
                <option value="967">🇾🇪 +967</option>
                <option value="20">🇪🇬 +20</option>
                <option value="218">🇱🇾 +218</option>
                <option value="216">🇹🇳 +216</option>
                <option value="213">🇩🇿 +213</option>
                <option value="212">🇲🇦 +212</option>
                <option value="222">🇲🇷 +222</option>
                <option value="223">🇲🇱 +223</option>
                <option value="224">🇬🇳 +224</option>
                <option value="225">🇨🇮 +225</option>
                <option value="226">🇧🇫 +226</option>
                <option value="227">🇳🇪 +227</option>
                <option value="228">🇹🇬 +228</option>
                <option value="229">🇧🇯 +229</option>
                <option value="230">🇲🇺 +230</option>
                <option value="231">🇱🇷 +231</option>
                <option value="232">🇸🇱 +232</option>
                <option value="233">🇬🇭 +233</option>
                <option value="234">🇳🇬 +234</option>
                <option value="235">🇹🇩 +235</option>
                <option value="236">🇨🇫 +236</option>
                <option value="237">🇨🇲 +237</option>
                <option value="238">🇨🇻 +238</option>
                <option value="239">🇸🇹 +239</option>
                <option value="240">🇬🇶 +240</option>
                <option value="241">🇬🇦 +241</option>
                <option value="242">🇨🇬 +242</option>
                <option value="243">🇨🇩 +243</option>
                <option value="244">🇦🇴 +244</option>
                <option value="245">🇬🇼 +245</option>
                <option value="246">🇮🇴 +246</option>
                <option value="248">🇸🇨 +248</option>
                <option value="249">🇸🇩 +249</option>
                <option value="250">🇷🇼 +250</option>
                <option value="251">🇪🇹 +251</option>
                <option value="252">🇸🇴 +252</option>
                <option value="253">🇩🇯 +253</option>
                <option value="254">🇰🇪 +254</option>
                <option value="255">🇹🇿 +255</option>
                <option value="256">🇺🇬 +256</option>
                <option value="257">🇧🇮 +257</option>
                <option value="258">🇲🇿 +258</option>
                <option value="260">🇿🇲 +260</option>
                <option value="261">🇲🇬 +261</option>
                <option value="262">🇷🇪 +262</option>
                <option value="263">🇿🇼 +263</option>
                <option value="264">🇳🇦 +264</option>
                <option value="265">🇲🇼 +265</option>
                <option value="266">🇱🇸 +266</option>
                <option value="267">🇧🇼 +267</option>
                <option value="268">🇸🇿 +268</option>
                <option value="269">🇰🇲 +269</option>
                <option value="290">🇸🇭 +290</option>
                <option value="291">🇪🇷 +291</option>
                <option value="297">🇦🇼 +297</option>
                <option value="298">🇫🇴 +298</option>
                <option value="299">🇬🇱 +299</option>
                <option value="350">🇬🇮 +350</option>
                <option value="500">🇫🇰 +500</option>
                <option value="501">🇧🇿 +501</option>
                <option value="502">🇬🇹 +502</option>
                <option value="503">🇸🇻 +503</option>
                <option value="504">🇭🇳 +504</option>
                <option value="505">🇳🇮 +505</option>
                <option value="506">🇨🇷 +506</option>
                <option value="507">🇵🇦 +507</option>
                <option value="508">🇵🇲 +508</option>
                <option value="509">🇭🇹 +509</option>
                <option value="590">🇬🇵 +590</option>
                <option value="591">🇧🇴 +591</option>
                <option value="592">🇬🇾 +592</option>
                <option value="593">🇪🇨 +593</option>
                <option value="594">🇬🇫 +594</option>
                <option value="595">🇵🇾 +595</option>
                <option value="596">🇲🇶 +596</option>
                <option value="597">🇸🇷 +597</option>
                <option value="598">🇺🇾 +598</option>
                <option value="599">🇧🇶 +599</option>
                <option value="670">🇹🇱 +670</option>
                <option value="672">🇦🇶 +672</option>
                <option value="673">🇧🇳 +673</option>
                <option value="674">🇳🇷 +674</option>
                <option value="675">🇵🇬 +675</option>
                <option value="676">🇹🇴 +676</option>
                <option value="677">🇸🇧 +677</option>
                <option value="678">🇻🇺 +678</option>
                <option value="679">🇫🇯 +679</option>
                <option value="680">🇵🇼 +680</option>
                <option value="681">🇼🇫 +681</option>
                <option value="682">🇨🇰 +682</option>
                <option value="683">🇳🇺 +683</option>
                <option value="684">🇦🇸 +684</option>
                <option value="685">🇼🇸 +685</option>
                <option value="686">🇰🇮 +686</option>
                <option value="687">🇳🇨 +687</option>
                <option value="688">🇹🇻 +688</option>
                <option value="689">🇵🇫 +689</option>
                <option value="690">🇹🇰 +690</option>
                <option value="691">🇫🇲 +691</option>
                <option value="692">🇲🇭 +692</option>
                <option value="850">🇰🇵 +850</option>
                <option value="852">🇭🇰 +852</option>
                <option value="853">🇲🇴 +853</option>
                <option value="855">🇰🇭 +855</option>
                <option value="856">🇱🇦 +856</option>
                <option value="880">🇧🇩 +880</option>
                <option value="886">🇹🇼 +886</option>
                <option value="960">🇲🇻 +960</option>
                <option value="961">🇱🇧 +961</option>
                <option value="962">🇯🇴 +962</option>
                <option value="963">🇸🇾 +963</option>
                <option value="964">🇮🇶 +964</option>
                <option value="965">🇰🇼 +965</option>
                <option value="966">🇸🇦 +966</option>
                <option value="967">🇾🇪 +967</option>
                <option value="968">🇴🇲 +968</option>
                <option value="970">🇵🇸 +970</option>
                <option value="971">🇦🇪 +971</option>
                <option value="972">🇮🇱 +972</option>
                <option value="973">🇧🇭 +973</option>
                <option value="974">🇶🇦 +974</option>
                <option value="975">🇧🇹 +975</option>
                <option value="976">🇲🇳 +976</option>
                <option value="977">🇳🇵 +977</option>
                <option value="992">🇹🇯 +992</option>
                <option value="993">🇹🇲 +993</option>
                <option value="994">🇦🇿 +994</option>
                <option value="995">🇬🇪 +995</option>
                <option value="996">🇰🇬 +996</option>
                <option value="998">🇺🇿 +998</option>
              </select>
              <input
                type="tel"
                class="form-control"
                id="mobileNumber"
                v-model="form.mobileNumber"
                :class="{ 'is-invalid': errors.mobileNumber }"
                placeholder="Enter mobile number"
                required
              />
            </div>
            <div v-if="errors.mobileNumber" class="invalid-feedback">
              {{ errors.mobileNumber }}
            </div>
            <small class="form-text text-muted">
              Enter your mobile number
            </small>
          </div>

          <!-- Error Alert -->
          <div v-if="error" class="alert alert-danger" role="alert">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ error }}
          </div>

          <!-- Action Buttons -->
          <div class="d-grid gap-2">
            <!-- Signup Button (Primary) -->
            <button
              type="button"
              class="btn btn-primary w-100"
              @click="goToSignup"
            >
              <i class="fas fa-user-plus me-2"></i>
              Sign Up
            </button>

            <!-- Login Button (Secondary) -->
            <button
              type="submit"
              class="btn btn-outline-primary w-100"
              :disabled="isLoading"
            >
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
              >
                <span class="visually-hidden">Loading...</span>
              </span>
              <i v-else class="fas fa-sign-in-alt me-2"></i>
              {{ isLoading ? "Checking..." : "Login" }}
            </button>
          </div>
        </form>

        <!-- Additional Info -->
        <div class="text-center mt-3">
          <p class="text-muted mb-0 small">
            Already have an account? Use the Login button above.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "MobileLogin",
  data() {
    return {
      currentStep: 1,
      form: {
        mobileNumber: "",
        countryCode: "91", // Default to India
      },
      errors: {},
      error: null,
      isLoading: false,
    };
  },

  methods: {
    ...mapActions("auth", ["mobileLogin"]),

    validateMobile() {
      this.errors = {};

      if (!this.form.mobileNumber) {
        this.errors.mobileNumber = "Mobile number is required";
      } else if (!/^\d+$/.test(this.form.mobileNumber)) {
        this.errors.mobileNumber = "Please enter a valid mobile number";
      }

      return Object.keys(this.errors).length === 0;
    },

    goToSignup() {
      // Check if we have a mobile number
      if (!this.form.mobileNumber) {
        Swal.fire({
          title: "Mobile Number Required",
          text: "Please enter your mobile number first before signing up.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }

      // Clear any existing authentication state before going to signup
      this.$store.dispatch("auth/logout");

      // Navigate to signup with mobile number and country code
      try {
        this.$router.push({
          path: "/signup",
          query: {
            mobile: this.form.mobileNumber,
            countryCode: this.form.countryCode,
          },
        });
      } catch (error) {
        console.error("Navigation failed:", error);
        // Fallback to window.location
        window.location.href = `/signup?mobile=${this.form.mobileNumber}&countryCode=${this.form.countryCode}`;
      }
    },

    async checkUserAndLogin() {
      if (!this.validateMobile()) {
        return;
      }

      this.isLoading = true;
      this.error = null;

      try {
        // First, check if user exists
        const checkResponse = await axios.post("/mobile/auth/check-user", {
          mobileNumber: this.form.mobileNumber,
          countryCode: this.form.countryCode,
        });

        if (checkResponse.data.success) {
          if (checkResponse.data.userExists) {
            // User exists, login directly
            await this.directLogin();
          } else {
            // User doesn't exist, redirect to signup
            await Swal.fire({
              title: "Account Not Found",
              text: "No account found with this mobile number. Please sign up first.",
              icon: "info",
              confirmButtonText: "Go to Sign Up",
              showCancelButton: true,
              cancelButtonText: "Cancel",
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push("/signup");
              }
            });
          }
        } else {
          throw new Error(checkResponse.data.error || "Failed to check user");
        }
      } catch (error) {
        console.error("Check user error:", error);
        this.error =
          error.response?.data?.error ||
          error.message ||
          "Failed to check user";

        Swal.fire({
          title: "Error",
          text: this.error,
          icon: "error",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async directLogin() {
      try {
        const response = await axios.post("/mobile/auth/direct-login", {
          mobileNumber: this.form.mobileNumber,
          countryCode: this.form.countryCode,
        });

        if (response.data.success) {
          // Store user data in Vuex
          await this.mobileLogin(response.data);

          // Show success message
          await Swal.fire({
            title: "Welcome Back!",
            text: "Login successful",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });

          // Redirect to trips page
          this.$router.push("/trips");
        } else {
          throw new Error(response.data.error || "Login failed");
        }
      } catch (error) {
        console.error("Direct login error:", error);
        this.error =
          error.response?.data?.error || error.message || "Login failed";

        Swal.fire({
          title: "Login Failed",
          text: this.error,
          icon: "error",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
        });
      }
    },

    clearForm() {
      this.form.mobileNumber = "";
      this.errors = {};
      this.error = null;
      this.currentStep = 1;
    },
  },

  created() {
    // Get mobile number and country code from query params
    this.form.mobileNumber = this.$route.query.mobile || "";
    this.form.countryCode = this.$route.query.countryCode || "91";

    if (!this.form.mobileNumber) {
      // Redirect to login if no mobile number
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.mobile-auth-container {
  background: url("https://gypsy-souls-website.s3.ap-south-1.amazonaws.com/login-bg.jpg") center center / cover no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  position: relative;
}

.mobile-auth-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.mobile-auth-card {
  background: rgba(245, 242, 237, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(44, 36, 25, 0.2);
  padding: 2rem;
  width: 100%;
  max-width: 400px;
  position: relative;
  overflow: hidden;
  z-index: 2;
  border: 1px solid rgba(180, 100, 40, 0.2);
}

.mobile-auth-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #b46428, #78501e);
}

.auth-logo {
  text-align: center;
  margin-bottom: 2rem;
}

.auth-logo-img {
  height: 80px;
  width: auto;
  max-width: 300px;
  object-fit: contain;
  margin-bottom: 1rem;
  transition: transform 0.3s ease;
}

.auth-logo-img:hover {
  transform: scale(1.05);
}

.auth-logo h1 {
  background: linear-gradient(135deg, #b46428, #78501e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.auth-logo p {
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0;
}

.auth-step {
  animation: slideIn 0.3s ease-out;
}

.step-title {
  color: #333;
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
}

.step-subtitle {
  color: #6c757d;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

.form-control:focus {
  border-color: #b46428;
  box-shadow: 0 0 0 0.2rem rgba(180, 100, 40, 0.25);
}

.input-group-text {
  background-color: #f5f2ed;
  border-color: #ced4da;
  color: #495057;
  font-weight: 600;
}

.btn-primary {
  background: linear-gradient(135deg, #b46428, #78501e);
  border: none;
  font-weight: 600;
  padding: 0.75rem;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #966428, #5a6446);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(180, 100, 40, 0.4);
}

.btn-outline-secondary {
  border-color: #6c757d;
  color: #6c757d;
  border-radius: 10px;
  font-weight: 600;
}

.btn-outline-secondary:hover {
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-outline-primary {
  border-color: #b46428;
  color: #b46428;
  border-radius: 10px;
}

.btn-outline-primary:hover {
  background-color: #b46428;
  border-color: #b46428;
}

.btn-link {
  color: #b46428;
  text-decoration: none;
  font-weight: 600;
}

.btn-link:hover {
  color: #966428;
  text-decoration: underline;
}

.alert {
  border-radius: 10px;
  border: none;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.form-text {
  font-size: 0.8rem;
}

.border-top {
  border-color: #e9ecef !important;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 576px) {
  .mobile-auth-card {
    margin: 1rem;
    padding: 1.5rem;
  }

  .auth-logo-img {
    height: 60px;
    max-width: 250px;
  }

  .auth-logo h1 {
    font-size: 1.75rem;
  }

  .step-title {
    font-size: 1.1rem;
  }
}
</style>
